'use client';

import { datadogRum } from '@datadog/browser-rum-slim';
import { useEffect } from 'react';
import type { RedirectTestArm } from './redirectExposureHandoff';

interface RedirectTestRumContextProps {
  experimentId: string;
  arm: RedirectTestArm;
}

/** Splits RUM page performance by arm; treatment's view timings start before its 302, so they include the extra hop. */
export function RedirectTestRumContext({ experimentId, arm }: RedirectTestRumContextProps) {
  useEffect(() => {
    datadogRum.setViewContextProperty('redirectTest', { experimentId, arm });
  }, [experimentId, arm]);

  return null;
}
